<div class="modal-header" style="padding: 15px !important; border-bottom: 1px solid #e5e5e5;">
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true"
        (click)="closeModal()">&times;</button>
    <h4 class="modal-title wrap-text-in">{{type}} End Client</h4>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-xs-12" *ngIf="type === 'Delete'">
            <p *ngIf="!endClientDetails || endClientDetails.length == 0">Deleting the End client <span style="color:#03a9f4">'{{addEditClientName}}'</span> will delete it from requisition.</p>
            <p *ngIf="endClientDetails && endClientDetails.length > 0">Deleting the End client <span style="color:#03a9f4">'{{addEditClientName}}'</span> will delete it from associated requisitions as well.</p>
            <div class="mb-3" *ngIf="endClientDetails && endClientDetails.length > 0" style="max-height: 250px; overflow-y: auto;">
                <table class="table table-bordered mb-2">
                    <tr>
                        <th class="pl-4">Req No</th>
                        <th class="pl-4">Req Title</th>
                    </tr>
                    <tr *ngFor="let requisition of endClientDetails">
                        <td class="pl-4">{{requisition.split(' ')[0]}}</td>
                        <td class="pl-4">{{requisition.split(' ').splice(1).toString().replaceAll(',', ' ')}}</td>
                    </tr>
                </table>
            </div>
            <p class="mb-2">Are you sure you want to continue?</p>
        </div>
        <div *ngIf="type != 'Delete'" class="col-xs-12 mt-2 form-group" [ngClass]="{'has-error': isEndClientNameValid}">
            <label for="addEditEndClient" class="control-label">Name <em>*</em> : </label>
            <input type="text" class="form-control" id="addEditEndClient" [(ngModel)]="addEditClientName" [disabled]="type === 'Delete'"
                name="addEditEndClient" minlength="1" placeholder="Enter end client name" (ngModelChange)="(!addEditClientName || addEditClientName.length === 0 || addEditClientName.length > 25) ? isEndClientNameValid = true : isEndClientNameValid = false">
            <small class="error" *ngIf="addEditClientName.length > 25 && type != 'Delete'">Name can have maximum 25 characters.</small>
        </div>
        <div class="col-xs-12 mt-3">
            <button class="btn btn-primary pull-right" [ngClass]="{'btn-danger': type === 'Delete'}" (click)="(addEditClientName.length > 0 && addEditClientName.length < 26) ? saveCallback(type, addEditClientName) : isEndClientNameValid = true">
                <span>
                    {{type === 'Edit' ? 'Save' : type}}
                </span>
            </button>
        </div>
    </div>
</div>
